var ImageGrid = require('./ImageGrid');

module.exports = ImageGrid;
